import qs from 'qs';
import axios from 'axios';
import { createActionType } from 'utils/redux';
import { handleErrors } from 'utils/api';
import { apiGetMentions, apiUpdateMention } from 'constants/apiRouting';
import {
  GET_MENTIONS as GET_MENTIONS_EVENT,
  EDIT_MENTION as EDIT_MENTION_EVENT,
} from 'constants/analytics';
import { analyticsTrack } from 'utils/analytics';
import { isEmpty, isInteger } from 'lodash';

export const GET_MENTIONS = createActionType('GET_MENTIONS');
export const CREATE_MENTION = createActionType('CREATE_MENTION');
export const EDIT_MENTION = createActionType('EDIT_MENTION');

export const getMentions = (params = {
  account__id: null,
  campaign__id: null,
  start_date: null,
  end_date: null,
  page: 1,
  has_opportunity: null,
}) => async (dispatch) => {
  analyticsTrack(GET_MENTIONS_EVENT, {
    ...params,
  }, true);

  await dispatch({
    type: GET_MENTIONS.name,
    payload: axios.get(apiGetMentions(), {
      params,
      withCredentials: true,
      paramsSerializer: p => qs.stringify(p),
    })
      .catch(error => handleErrors(error, dispatch)),
  });
};

export const createMention = mention => async (dispatch) => {
  await dispatch({
    type: CREATE_MENTION.name,
    payload: axios.post(apiGetMentions(), {
      outlet_id: mention.outlet.value,
      account_id: mention.account.value,
      sequence_id: !isEmpty(mention.sequence) ? mention.sequence.value : null,
      campaign_id: !isEmpty(mention.campaign) ? mention.campaign.value : null,
      opportunity_id: !isEmpty(mention.opportunity) ? mention.opportunity.value : null,
      article_authors: mention.author,
      article_title: mention.title,
      article_url: mention.articleURL,
      article_published_at: isInteger(mention.date)
        ? new Date(mention.date)
        : mention.date,
      note: mention.note,
      article_type: !isEmpty(mention.article_type) ? mention.article_type.value : null,
      follow_status: !isEmpty(mention.follow_status) ? mention.follow_status.value : null,
    }, {
      withCredentials: true,
    }).then((response => response)).catch(error => handleErrors(error, dispatch)),
  });
};

export const editMention = mention => async (dispatch) => {
  analyticsTrack(EDIT_MENTION_EVENT, {
    ...mention,
  }, true);
  await dispatch({
    type: EDIT_MENTION.name,
    payload: axios.put(apiUpdateMention(mention.id), {
      outlet_id: mention.outlet.value,
      account_id: mention.account.value,
      sequence_id: !isEmpty(mention.sequence) ? mention.sequence.value : null,
      campaign_id: !isEmpty(mention.campaign) ? mention.campaign.value : null,
      opportunity_id: !isEmpty(mention.opportunity) ? mention.opportunity.value : null,
      article_authors: mention.author,
      article_title: mention.title,
      article_url: mention.articleURL,
      article_published_at: isInteger(mention.date)
        ? new Date(mention.date)
        : mention.date,
      note: mention.note,
      article_type: !isEmpty(mention.article_type) ? mention.article_type.value : null,
      follow_status: !isEmpty(mention.follow_status) ? mention.follow_status.value : null,
    }, {
      withCredentials: true,
    }).catch(error => handleErrors(error, dispatch)),
  });
};
